import { render } from "./MainSlide.vue?vue&type=template&id=6107c05e&scoped=true"
import script from "./MainSlide.vue?vue&type=script&lang=js"
export * from "./MainSlide.vue?vue&type=script&lang=js"

import "./MainSlide.vue?vue&type=style&index=0&id=6107c05e&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/brightflame/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6107c05e"]])

export default __exports__